export const BASE_URL = process.env.VITE_HOST;

export const EXTERNAL_LINKS = {
	EXAMPLE: 'https://example.com',
	YOUTUBE: 'https://www.youtube.com/c/testometrika',
	TELEGRAM: 'https://t.me/testometrika_com',
	VK: 'https://vk.com/testometrika',
	APPSTORE: 'https://apps.apple.com/ru/app/id1483182154?l=ru&ls=1',
	GOOGLEPLAY: 'https://play.google.com/store/apps/details?id=com.testometrika.tests',
	GITHUB: '',
	YOUTUBE_WIDGET: '',
};

export const ROUTES = {
	HOME: `/`,
	TESTS: `${BASE_URL}/tests/`,
	LOGIN: `/user/auth/?register=yes`,
	PROFILE: `/user/`,
	MY_TESTS: `/user/#my-tests`,
	CONTACTS: `/contacts/`,
	PAY_WIDGET: ``,
	ATTEMPTS: `${BASE_URL}/a/`,
	WIDGETS: `/user/#wgt-profile`,
	WIDGETS_DEMO_FREE: `/w/demo/?tariff=free`,
	WIDGETS_DEMO_PREMIUM: `/w/demo/`,
	WIDGETS_DEMO_INDIVIDUAL: `/w/demo/`,
};


